import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
export const AuthorizeAction = handler => ({
  id: 'connect-account',
  text: /*#__PURE__*/React.createElement(FormattedMessage, messages.connect_link_account_card),
  promise: () => new Promise(resolve => resolve(handler())),
  buttonAppearance: 'default'
});